<template>
  <g fill-rule="evenodd">
    <path d="M22.5 12.01a10.5 10.5 0 01-21-.02v-.02a10.5 10.5 0 0121 .04z" />
    <path
      d="M16.17 9.82a1.15 1.15 0 00-1.59 0l-3.18 3.06-1.98-1.91a1.15 1.15 0 00-1.6 0c-.43.42-.43 1.1 0 1.53l2.79 2.68c.22.21.5.32.8.32.28 0 .57-.1.79-.32l3.97-3.83c.44-.42.44-1.1 0-1.53"
      fill="#FFF"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AudiencesIcon",
});
</script>
